/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import adjustmentService from './../../../../services/adjustment';
import adjustmentTransformer from './../../../../transformers/adjustment';
import warehouseService from './../../../../services/warehouse';

export default {
  data() {
    return {
      loading: true,
      tabIndex: 'first',
      currentAdjustment:{
        products:[],
        warehouse:{
          name:'',
        },
        stock:{
          name:'',
        }
      },
    };
  },

  computed: {

    productList() {
      return this.currentAdjustment.products.map(c => ({
        sku: c.product.sku,
        name: c.product.name,
        qty: c.qty,
        exciseAdditionalCode: c.exciseAdditionalCode ? c.exciseAdditionalCode.code+' ('+c.exciseAdditionalCode.description+')' : ''
      }));
    },

  },

  watch: {
    currentAdjustment: function(currentAdjustment){
      console.log(currentAdjustment);
    }
  },

  created() {
     this.loading = false;
  },

  methods: {

  },
  mounted(){
     Promise.all([
        adjustmentService.show(this.$route.params.id),
      ]).then((data) => {
          this.currentAdjustment = data[0];
      });
  },
  components: {
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/adjustment/view/view.js